<template>
    <div class="page-devices">
        <div class="left">
            <el-date-picker :clearable="false" v-model="nyr" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="handleTrackDate" style="width:200px;margin-bottom: 10px;"></el-date-picker>
            <el-input type="textarea" placeholder="多设备号请换行分割" v-model="textarea"></el-input>
            <el-button type="primary" plain size="small" @click="handleSubmit" :loading="loading">查询({{dynamicTags.length}})</el-button>
        </div>
        <div class="right">
            <div class="up">
                <div id="map"></div>
            </div>
            <div class="down" ref="down">
                <div class="ul">
                    <div class="li" :class="{active: dIndex === index}" v-for="(item, index) in deviceTracks" :key="index" @click="handleDevice(index)">
                        <span style="width:110px;margin-right: 10px;" @click.stop.prevent="handleCode(index)">{{ item.code }}</span>
                        <el-tag type="info" size="mini" effect="plain" :style="{color:'#fff', backgroundColor: tag.bgColor,borderColor: dIndex === index && tIndex === idx ? borderColor : defaultBorderColor}" @click.stop.prevent="handleTag(index, idx)" v-for="(tag, idx) in tags" :key="idx">{{tag.name}}:{{dotNum(item,tag.loc_type)}}</el-tag>
                        <div class="dots">
                            <div class="dot" :style="{backgroundColor:filterColor(tag.loc_type),borderColor: dIndex === index && pIndex === idx ? borderColor : defaultBorderColor}" v-for="(tag, idx) in item.data" :key="idx" @click.stop.prevent="handlePoint(index, idx)">
                                <el-tooltip effect="dark" placement="top" :disabled="!tag.filter_reason">
                                    <template slot="content">
                                        {{ tag.filter_reason }}
                                    </template>
                                    <p>
                                        <i :style="{backgroundColor:filterColor(5)}" v-if="tag.filter_type === 0"></i>
                                        <span>{{idx}}</span>
                                    </p>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                    <div class="li" v-if="deviceTracks.length > pageSize && dynamicTags.length > deviceTracks.length">
                        <el-button type="primary" size="small" @click="loadMore(pageNum + 1)" :loading="loading">加载更多</el-button>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="deviceCode + ' 详情'" :visible.sync="descData.length ? true : false" width="1100px" @close="descData = []">
            <template v-if="descData.filter(item=>item.filter_type === 0).length">
                <p>过滤点详情见下方列表：</p>
                <div style="max-height: 300px; overflow-y: auto;">
                    <ul>
                        <template v-for="(item, index) in descData">
                            <li v-if="item.filter_type === 0" :key="index">
                                点 {{ index }}：{{ item.filter_reason || '无原因说明' }}
                            </li>
                        </template>
                    </ul>
                </div>
            </template>
            <p>点时间间隔详情见下方列表：</p>
            <div style="max-height: 300px; overflow-y: auto;">
                <ul>
                    <template v-for="(item, index) in descData">
                        <li v-if="index !== 0" :key="index">
                            点 {{ index - 1 }}[{{ descData[index - 1].time }}]~{{ index }}[{{ item.time }}]：{{ timeCalculate(descData[index - 1].time, item.time) }}
                        </li>
                    </template>
                </ul>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { lazyAMapApiLoaderInstance } from 'vue-amap'
    import { getHistoryTrack } from '../api'
    import { timeCalculate } from '@/utils/tool';
    export default {
        data () {
            return {
                nyr: '',
                deviceTracks: [],
                map: null,
                dIndex: -1,
                pIndex: -1,
                tIndex: -1,
                textarea: '',
                pageNum: 1,
                pageSize: 10,
                loading: false,
                tags: [
                    { name: 'WIFI', loc_type: 1, bgColor: '#40A9FF' },
                    { name: 'GPS', loc_type: 2, bgColor: '#36CFC9' },
                    { name: '基站', loc_type: 3, bgColor: '#FFD700' },
                    { name: '居家WiFi', loc_type: 4, bgColor: '#9B59B6' },
                    { name: '已过滤', loc_type: 5, bgColor: '#FF4C4C' },
                    { name: '未过滤', loc_type: 6, bgColor: '#FF69B4' }
                ],
                borderColor: 'blue',
                defaultBorderColor: '#ccc',
                descData: [],
                deviceCode: ''
            }
        },
        computed: {
            dynamicTags () {
                const arr = this.textarea.split(/\r?\n/).map(s => s.trim()).filter(Boolean);
                return arr;
            },
            filterColor () {
                return (loc_type) => {
                    return this.tags.find(t => t.loc_type === loc_type)?.bgColor || '#000';
                }
            }
        },
        async mounted () {
            this.textarea = localStorage.getItem('cyy_devices') ? localStorage.getItem('cyy_devices') : ''
            const date = new Date();
            const formatObj = {
                y: date.getFullYear(),
                m: date.getMonth() + 1,
                d: date.getDate(),
                h: date.getHours(),
                i: date.getMinutes(),
                s: date.getSeconds(),
                a: date.getDay()
            }
            this.nyr = `${formatObj.y}-${formatObj.m.toString().padStart(2, '0')}-${formatObj.d.toString().padStart(2, '0')}`
            console.log('this.nyr', this.nyr);
            lazyAMapApiLoaderInstance.load().then(() => {
                this.map = new AMap.Map("map", {
                    resizeEnable: true,
                    center: [116.397428, 39.90923],
                    zoom: 13,
                });
            }).catch(e => {
                console.error('AMap 加载失败', e);
            })
        },
        methods: {
            handleTrackDate (val) {
                this.nyr = val;
                this.handleSubmit();
            },
            timeCalculate (startTime, endTime) {
                return timeCalculate(startTime, endTime);
            },
            dotNum (item, loc_type) {
                const data = item.data || [];
                if (loc_type === 5) {
                    return data.filter(o => o.filter_type === 0).length
                }
                else if (loc_type === 6) {
                    return data.filter(o => o.filter_type !== 0).length
                }
                return data.filter(o => o.loc_type === loc_type).length
            },
            handleSubmit () {
                if (this.dynamicTags.length > 0) {
                    localStorage.setItem('cyy_devices', this.textarea.trim());
                    this.deviceTracks = [];
                    this.loadMore(1);
                } else {
                    this.$message.warning('请输入查询内容');
                }
            },
            handleCode (index) {
                this.deviceCode = this.deviceTracks[index].code;
                this.descData = this.deviceTracks[index].data;
            },
            handleDevice (index) {
                this.dIndex = index;
                this.pIndex = -1;
                this.createTrackMarker(true);
            },
            handleTag (dIndex, tIndex) {
                if (this.dIndex === dIndex) {
                    if (this.tIndex === tIndex) {
                        this.tIndex = -1;
                    } else {
                        this.tIndex = tIndex;
                    }
                    this.pIndex = -1;
                    this.createTrackMarker();
                }
            },
            handlePoint (dIndex, pIndex) {
                if (this.dIndex === dIndex) {
                    if (this.pIndex === pIndex) {
                        this.pIndex = -1;
                    } else {
                        this.pIndex = pIndex;
                    }
                    this.createTrackMarker();
                }
            },
            async loadMore (pageNum) {
                this.pageNum = pageNum;
                const startIndex = (this.pageNum - 1) * this.pageSize;
                const endIndex = Math.min(this.pageNum * this.pageSize, this.dynamicTags.length);
                this.loading = true;
                const promises = [];
                for (let i = startIndex; i < endIndex; i++) {
                    const code = this.dynamicTags[i];
                    const p = getHistoryTrack(code, this.nyr)
                        .then((data) => {
                            this.deviceTracks.push({ code, data: data.data.data });
                        })
                        .catch((err) => {
                            console.error(err);
                        });
                    promises.push(p);
                }
                await Promise.all(promises);
                this.loading = false;
                if (this.dIndex === -1 && this.deviceTracks.length > 0) {
                    this.dIndex = 0;
                    this.createTrackMarker(true);
                } else {
                    this.map.clearMap()
                }
            },
            createTrackMarker (isSetFitView) {
                if (!this.map) {
                    return;
                }
                this.map.clearMap()
                const { data = [] } = this.deviceTracks[this.dIndex];
                const isVisible = (point) => {
                    if (this.tIndex === -1) {
                        return true;
                    }
                    if (this.tags[this.tIndex].loc_type === 5) {
                        return point.filter_type === 0;
                    } else if (this.tags[this.tIndex].loc_type === 6) {
                        return point.filter_type !== 0;
                    } else {
                        return point.loc_type === this.tags[this.tIndex].loc_type;
                    }
                }
                data.forEach((point, idx) => {
                    const tag = this.tags.find(t => t.loc_type === point.loc_type) || { bgColor: '#000' };
                    var marker = new AMap.Text({
                        text: idx.toString(),
                        anchor: "center",
                        draggble: false,
                        cursor: "pointer",
                        angle: 0,
                        zIndex: this.pIndex === idx ? 10 : 1,
                        //visible: isVisible(point),
                        style: {
                            'background-color': tag.bgColor,
                            'color': point.filter_type === 0 ? this.filterColor(5) : '#fff',
                            'border': '1px solid ' + (this.pIndex === idx ? this.borderColor : '#ccc'),
                            'box-shadow': this.pIndex === idx ? `0 0 10px ${this.borderColor}` : 'none',
                            opacity: isVisible(point) ? 1 : 0.05
                        },
                        position: [point.longitude, point.latitude]
                    })
                    marker.setMap(this.map)
                });
                isSetFitView && this.map.setFitView()
            }
        }
    }
</script>
<style lang="less" scoped>
    .page-devices {
        display: flex;
        flex-direction: row;
        height: 100%;
        overflow: hidden;
        .left {
            display: flex;
            flex-direction: column;
            width: 200px;
            height: 100%;
            overflow: hidden;
            .el-textarea {
                flex: 1;
                ::v-deep .el-textarea__inner {
                    height: 100%;
                }
            }
            .el-button {
                margin-top: 10px;
            }
        }
        .right {
            margin-left: 10px;
            flex: 1;
            height: 100%;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            .down {
                height: 300px;
                overflow-x: hidden;
                overflow-y: auto;
                .ul {
                    .li {
                        display: flex;
                        align-items: center;
                        flex-direction: row;
                        min-height: 30px;
                        border-bottom: 1px solid #eee;
                        cursor: pointer;
                        padding: 0 10px;
                        &:last-child {
                            border-bottom: none;
                        }
                        &:nth-child(2n) {
                            background-color: #f9f9f9;
                        }
                        &.active {
                            background-color: #f0f9eb;
                            color: #67c23a;
                        }
                        &:hover {
                            background-color: #f5f7fa;
                        }
                        .el-tag {
                            margin-right: 5px;
                        }
                        .dots {
                            display: flex;
                            flex-direction: row;

                            flex-wrap: wrap;
                            .dot {
                                position: relative;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                min-width: 22px;
                                height: 22px;
                                border-radius: 50%;
                                background-color: #eee;
                                font-size: 12px;
                                color: #fff;
                                margin-right: 5px;
                                overflow: hidden;
                                border: 1px solid #ccc;
                                i {
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 50%;
                                }
                                span {
                                    position: relative;
                                    z-index: 1;
                                }
                            }
                        }
                    }
                }
            }
            .up {
                margin-bottom: 10px;
                flex: 1;
                #map {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
</style>